import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, LimitChangeBarring, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrderMiniDTO } from 'src/app/core/models/system/order/order-mini.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { OrderUsageLimitsDTO } from 'src/app/core/models/system/order/order-usage-limits.dto';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UsageLimitsModalFormComponent } from '../../usage-limits-modal-form/usage-limits-modal-form.component';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-manage-esim-modal-form-more',
  templateUrl: './manage-esim-modal-form-more.component.html',
  styleUrls: ['./manage-esim-modal-form-more.component.scss']
})

export class ManageEsimModalFormMoreComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() moreFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() moreFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>();

  @ViewChild('completedModalForm',         { static: false }) completedModalForm!        : CompletedModalFormComponent;
  @ViewChild('deleteSimConfirmationModal', { static: false }) deleteSimConfirmationModal!: ConfirmationModalFormComponent;
  @ViewChild('manageEsimModalFormMore',    { static: false }) moreFormModal!             : TemplateRef<void>;
  @ViewChild('usageLimitsModalForm',       { static: false }) usageLimitsModalForm!      : UsageLimitsModalFormComponent;
  @ViewChild('warningModalForm',           { static: false }) warningModalForm!          : WarningModalFormComponent;
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private currOrderUsageLimits      : OrderUsageLimitsDTO | undefined;
  private formTitleDefault          : string="SIM Operations";
  private initialStatus             : string="Please select an operation";
  private moreFormModalRef!         : NgbModalRef;
  private sureSimOrder              : OrderDTO | undefined;
  private usageLimitsModalFormIsOpen: boolean=false;
   
  public alertColourProgress        : string=AlertClassColour.Green;
  public curUser                    : SystemUserDTO;
  public deprovisionInProgress      : boolean=false;
  public formSubmitted              : boolean=false;
  public formTitle                  : string=this.formTitleDefault;
  public highlightBtnChangeLimits   : boolean=false;
  public highlightBtnDeleteSim      : boolean=false;
  public highlightBtnEmailUser      : boolean=false;
  public highlightBtnEnable         : boolean=false;
  public highlightBtnNotifyUser     : boolean=false;
  public highlightBtnSmsUser        : boolean=false;
  public highlightBtnSuspend        : boolean=false;
  public moreForm!                  : UntypedFormGroup;
  public limitChangeButtonEnabled   : boolean=false;
  public limitChangeMessage         : string="";
  public possibleOrderUsageLimits   : OrderUsageLimitsDTO | undefined;
  public progressInformation        : string=this.initialStatus;
  public refreshCallingGrid         : boolean=false;
  public showMessagingArea          : boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimMoreMessaging, false);
  public submitButtonEnabled        : boolean=false;
  public sureSimOrderDetails        : OrderMiniDTO | undefined;
  public usageLimitsChanged         : boolean=false;

  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private devicesService       : DevicesService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal,
    private ordersService        : OrdersService
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress=AlertClassColour.Green;
      this.formSubmitted      =false;
      this.progressInformation=this.initialStatus;
      this.submitButtonEnabled=false;
      this.sureSimOrderDetails=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(sureSimOrderDetails: OrderMiniDTO): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
           
      if (sureSimOrderDetails != undefined) {
        this.sureSimOrderDetails=sureSimOrderDetails;
        this.formTitle          = this.formTitleDefault + " - " + this.sureSimOrderDetails?.iccid;

        this.getSureSimOrder();

        this.populateFormFields(this.moreForm);
        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.moreFormModalRef=this.modalService.open(this.moreFormModal, { backdrop: this.modalBackGround,
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Medium });
    }
    catch(e) {
      this.moreFormCancelled.emit(this.refreshCallingGrid);
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getSureSimOrder() {
    try {
      this.ordersService.getOrderWithSpend(<number>this.sureSimOrderDetails?.orderID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder=data;
          this.limitChangeButtonEnabled=true;
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region moreForm
  
  get formOfOrderDetails() {
    return this.moreForm.controls;
  }
  
  get formOfMore() {
    return this.moreForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.moreForm);
       this.moreForm=this.formBuilder.group({ });
      
      this.addFormFields(this.moreForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.addFormControl(formGroup, "alertProduct", "", []);
        this.addFormControl(formGroup, "iccid",        "", []);
        this.addFormControl(formGroup, "messageInput", "", []);
        this.addFormControl(formGroup, "orderNo",      "", []);
        this.addFormControl(formGroup, "username",     "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.moreForm) {
        this.moreForm.controls["alertProduct"].setValue(this.sureSimOrderDetails?.alertProduct);
        this.moreForm.controls["iccid"].setValue(this.sureSimOrderDetails?.iccid);
        this.moreForm.controls["messageInput"].setValue("");
        this.moreForm.controls["orderNo"].setValue(this.sureSimOrderDetails?.orderNo);
        this.moreForm.controls["username"].setValue(this.sureSimOrderDetails?.username);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.moreForm.valid) {
        this.saveOrder();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public moreFormCancel() {
    try {
      this.moreFormCancelled.emit(this.refreshCallingGrid);
      this.moreFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  //#region Save Order
  
  private saveOrderProcessComplete() {
    try {
      this.completedModalForm.openForm(this.limitChangeMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public saveOrder() {
    try {
      if (this.usageLimitsChanged) {
        this.sureSimOrder!.limit        =this.possibleOrderUsageLimits?.limit;
        this.sureSimOrder!.limitCurrent =this.possibleOrderUsageLimits?.limitCurrent;
        this.sureSimOrder!.limitSelfAuth=this.possibleOrderUsageLimits?.limitSelfAuth;
      }

      this.sureSimOrder!.updatedByUserId= this.curUser.userId;

      this.ordersService.save(<OrderDTO>this.sureSimOrder)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder = data;
          this.sureSimOrderDetails!.orderID = <number>this.sureSimOrder?.id;
          this.limitChangeButtonEnabled=true;
          this.refreshCallingGrid=true;
          this.simLimitChanged();
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  //#region changeLimits

  public changeLimits() {
    try {
      try {
        if (!this.usageLimitsModalFormIsOpen) {
          this.usageLimitsModalFormIsOpen=true;
          this.usageLimitsModalForm.openForm(this.sureSimOrder?.id ?? -1);
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public changeLimitsMouseLeave() {
    try {
      this.highlightBtnChangeLimits=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public changeLimitsMouseOver() {
    try {
      this.highlightBtnChangeLimits=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region deleteSim
  
  public deleteSim() {
    try {
      this.deleteSimConfirmationModal.openForm("Deprovision SIM", "Are you sure?");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deleteSimMouseLeave() {
    try {
      this.highlightBtnDeleteSim=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deleteSimMouseOver() {
    try {
      this.highlightBtnDeleteSim=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public yesDeleteSim() {
    try {
      this.deprovision();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region simLimitChanged

  public simLimitChanged() {
    try {
      this.limitChangeMessage = "Limits updated";
      if (this.sureSimOrderDetails?.iccid != null)
      {
        this.devicesService.simLimitChanged(this.sureSimOrderDetails?.iccid, this.sureSimOrderDetails?.systemUserID)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (data == LimitChangeBarring.Barred) {
              this.limitChangeMessage = "Limits updated, this SIM has exceeded its new spend limit so has been barred.";
            } else if (data == LimitChangeBarring.StillBarred) {
              this.limitChangeMessage = "Limits updated, this new spend limit is below the sims current spend so has remained barred.";
            } else if (data == LimitChangeBarring.Unbarred) {
              this.limitChangeMessage = "Limits updated, this SIM has been unbarred.";
            }

            this.saveOrderProcessComplete();
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to deprovision sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion 

  //#region cease

  public deprovision() {
    try {
      if (this.sureSimOrderDetails?.iccid != null)
      {
        this.deprovisionInProgress=true;
        this.devicesService.deprovision(this.sureSimOrderDetails?.iccid, this.sureSimOrderDetails?.systemUserID)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.refreshCallingGrid   =true;
            this.deprovisionInProgress=false;
            this.processComplete("The SIM has been ceased");
          },
          error: error => {
            this.deprovisionInProgress=false;
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to cease sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion  

  //#region emailUser
  
  public emailUser() {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public emailUserMouseLeave() {
    try {
      this.highlightBtnEmailUser=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public emailUserMouseOver() {
    try {
      this.highlightBtnEmailUser=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region enable
  
  public enable() {
    try {
      if (this.sureSimOrderDetails?.iccid != null)
        {
          this.devicesService.unsuspend(this.sureSimOrderDetails?.iccid, this.sureSimOrderDetails?.systemUserID)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.refreshCallingGrid=true;
              this.processComplete("The SIM has been enabled");
            },
            error: error => {
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableMouseLeave() {
    try {
      this.highlightBtnEnable=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableMouseOver() {
    try {
      this.highlightBtnEnable=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region notifyUser
  
  public completedModalHasBeenClosed() {
    try {
        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  public notifyUser() {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public notifyUserMouseLeave() {
    try {
      this.highlightBtnNotifyUser=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public notifyUserMouseOver() {
    try {
      this.highlightBtnNotifyUser=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private processComplete(message : string) {
    try {
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region remove alert product
  
  public removeAlertProduct() {
    try {
      if (this.sureSimOrderDetails?.iccid != null)
        {
          this.devicesService.removeAlertProductSim(this.sureSimOrderDetails?.iccid, this.sureSimOrderDetails?.systemUserID)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.refreshCallingGrid=true;
              if (this.sureSimOrderDetails != undefined) {
                this.sureSimOrderDetails.alertProduct = 'No';
                this.moreForm.controls["alertProduct"].setValue(this.sureSimOrderDetails?.alertProduct);
              }
              this.processComplete("The alert product has been removed.");
            },
            error: error => {
              if (error.message && error.message.includes("404")) {
                // this.warningMessageMain="Failed to enable sim";
                // this.warningMessageSub ="Please contact the application vendor for assistance";
                // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
              } else {
                this.exceptionsService.handleException(new Error(error));
              }
            }
          });
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public removeAlertProductMouseLeave() {
    try {
      this.highlightBtnEnable=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public removeAlertProductMouseOver() {
    try {
      this.highlightBtnEnable=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region smsUser
  
  public smsUser() {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public smsUserMouseLeave() {
    try {
      this.highlightBtnSmsUser=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public smsUserMouseOver() {
    try {
      this.highlightBtnSmsUser=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region suspend
  
  public suspend() {
    try {
      if (this.sureSimOrderDetails?.iccid != null)
      {
        this.devicesService.suspend(this.sureSimOrderDetails?.iccid, this.sureSimOrderDetails?.systemUserID)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.refreshCallingGrid=true;
            this.processComplete("The SIM has been suspended");
          },
          error: error => {
            if (error.message && error.message.includes("404")) {
              // this.warningMessageMain="Failed to suspend sim";
              // this.warningMessageSub ="Please contact the application vendor for assistance";
              // this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public suspendMouseLeave() {
    try {
      this.highlightBtnSuspend=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public suspendMouseOver() {
    try {
      this.highlightBtnSuspend=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsHaveChanged(): boolean | undefined {
    try {
      return this.currOrderUsageLimits?.limit        !=this.possibleOrderUsageLimits?.limit        ||
             this.currOrderUsageLimits?.limitCurrent !=this.possibleOrderUsageLimits?.limitCurrent ||
             this.currOrderUsageLimits?.limitSelfAuth!=this.possibleOrderUsageLimits?.limitSelfAuth;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }
  
  public usageLimitsModalFormSaved(orderUsageLimits: OrderUsageLimitsDTO) {
    try {
      this.usageLimitsModalFormIsOpen=false;

      this.possibleOrderUsageLimits=orderUsageLimits;
      this.usageLimitsChanged      =this.usageLimitsHaveChanged() ?? false;

      if (this.usageLimitsChanged ) {
        this.limitChangeButtonEnabled=false;
        this.saveOrder();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsModalFormHasBeenCancelled() {
    try {
      this.usageLimitsModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
